import React, { useContext } from "react";
import { AuthContext } from "@context/AuthContext";
import { MembershipContext } from "@context/MembershipContext";
import LoginFormBase from "@components/Form/LoginFormBase";

const MovieClubLoginComponent = () => {
    const { loginMovieClub } = useContext(AuthContext);
    const { selectedMembershipId } = useContext(MembershipContext);

    return (
        <LoginFormBase
            onSubmit={loginMovieClub}
            extraSubmitFields={{ membershipId: selectedMembershipId }}
            disabled={selectedMembershipId === 0}
        />
    );
};

export default MovieClubLoginComponent;
